//updated by dolphin on 10/25/2022, 11:36:16 AM.

"use strict";
const API = {
  "base": {
    "login": {
      "login": "/login",
      "refresh": "/system/auth/user/refresh",
      "autoLogin": "/login/autoLogin/{id}",
      "register": "/login/register",
      "forgetPassword": "/login/forgetPassword"
    }
  },
};

export default API;
